module.exports = {
  MEMBER: 'member',
  PRINTER: 'printer',
  FUSOR: 'fusor'
};
